import { createContext, useCallback, useContext, useState } from 'react';

const ResetPasswordContext = createContext();

const initialState = {
  isDisabled: false,
  isOpenEyePassword: false,
  isOpenEyeConfirmPassword: false,
  isSuccess: false,

  password: '',
  errorMessage: '',
  successMessage: '',
};

const ResetPasswordProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = useCallback((payload) => setState((prev) => ({ ...prev, ...payload })), []);
  const resetState = useCallback(() => setState(initialState), []);

  return <ResetPasswordContext.Provider value={{ updateState, resetState, state }}>{children}</ResetPasswordContext.Provider>;
};

export const useResetPasswordState = () => {
  return useContext(ResetPasswordContext);
};

export default ResetPasswordProvider;
